import styled from "@emotion/styled";
import { GlobalStore } from "../../../../../../store/global/GlobalStore";
import { ConnectedVia } from "./elements/ConnectedVia";
import {
  OptionClaimNooxBadges,
  OptionCopyAddress,
  OptionGetGuildRole,
  OptionViewOnExplorer,
} from "./elements/ProfileActionsOptions";
import { ProfileActionsDisconnectButton } from "./elements/DisconnectButton";
import { useIsMobile } from "hooks/useDeviceType";
import { formatAddress } from "utils/walletUtils";
import { Address } from "viem";

interface ProfileActionsContentWithConnectionProps {
  closeDisplay: () => void;
}

export const ProfileActionsContentWithConnection = ({
  closeDisplay,
}: ProfileActionsContentWithConnectionProps) => {
  const address = GlobalStore.useState(s => s.address);
  const formattedAddress = formatAddress(address as Address);
  const isMobile = useIsMobile();

  return (
    <>
      <Header isMobile={isMobile}>
        <Title>{formattedAddress}</Title>
        <ConnectedVia />
      </Header>

      <OptionCopyAddress />
      <OptionViewOnExplorer />
      <OptionGetGuildRole />
      <OptionClaimNooxBadges />

      <DisconnectButtonWrapper onClick={closeDisplay} isMobile={isMobile}>
        <ProfileActionsDisconnectButton />
      </DisconnectButtonWrapper>
    </>
  );
};

// Sub-components

const Header = styled.div<{ isMobile: boolean }>`
  margin: ${props => (props.isMobile ? "12px 0 18px 10px" : "12px 10px 24px 10px")};
`;

const Title = styled.h1`
  font-size: ${props => props.theme.fontSize[6]};
  font-weight: ${props => props.theme.fontWeights["work-sans-0"]};
  margin-bottom: 10px;
  line-height: 120%;
`;

const DisconnectButtonWrapper = styled.div<{ isMobile: boolean }>`
  margin-top: ${props => (props.isMobile ? "4px" : "0")};
`;
